class Company {
    constructor(arr) {
        this.$$_inner_hash = {}
        this.initData(arr)
    }
    initData(arr) {
        arr.forEach(item => {
            if (!this[item.company_id]) {
                this.$$_inner_hash[item.company_id] = {}
                this[item.company_id] = [] 
            }
            this[item.company_id].push(item)
            this.$$_inner_hash[item.company_id][item.team_id] = item
        });
    }
    companyTeamCorrespond(company_id, team_id) {
        if (!this.$$_inner_hash[company_id] || !this.$$_inner_hash[company_id][team_id]) {
            return false
        }
        return !!this.$$_inner_hash[company_id][team_id]
    }
    getTeamList(company_id) {
        return this[company_id] || []
    }
    getTeamDetail(company_id, team_id) {
        if (!this.$$_inner_hash[company_id] || !this.$$_inner_hash[company_id][team_id]) {
            return false
        }
        return this.$$_inner_hash[company_id][team_id]
    }
}

Company.f_name = 'CompanyTeamMappingClass'

export const CompanyTeamMappingClass = Company


class Team {
    constructor(arr) {
        this.$$_inner_hash = {}
        this.initData(arr)
    }
    initData(arr) {
        arr.forEach(item => {
            if (!this[item.team_id]) {
                this.$$_inner_hash[item.team_id] = {}
                this[item.team_id] = [] 
            }
            this[item.team_id].push(item)
            this.$$_inner_hash[item.team_id][item.company_id] = item
        });
    }
    companyTeamCorrespond(team_id, company_id) {
        
        if (!this.$$_inner_hash[team_id] || !this.$$_inner_hash[team_id][company_id]) {
            return false
        }
        return !!this.$$_inner_hash[team_id][company_id]
    }
    companyTeamCorrespondGetCompant(team_id) {
        if (this.$$_inner_hash[team_id]) {
            const company = Object.values(this.$$_inner_hash[team_id])[0]
            return company || null
        } else {
            return null
        }
    }
    getCompanyList(team_id) {
        return this[team_id] || []
    }
    getCompanyDetail(team_id, company_id) {
        if (!this.$$_inner_hash[team_id] || !this.$$_inner_hash[team_id][company_id]) {
            return false
        }
        return this.$$_inner_hash[team_id][company_id]
    }
    
}

Team.f_name = 'TeamCompanyMappingClass'

export const TeamCompanyMappingClass = Team
